<template>
	<div v-if="usePortalAuthEnabled">
		<Row class="flex-justify-space-between width-100">
			<div>
				<MaybeUpgradeRequiredIndicator :billingFeatureId="billingFeatureId">
					<template #default="{ indicator, isUpgradeRequired }">
						<Row class="flex-align-center">
							<h2>Authenticate user identity</h2>
							<component class="ml-2" :is="indicator" :billingFeatureId="billingFeatureId" canBuild iconOnly v-if="isUpgradeRequired" />
						</Row>
					</template>
				</MaybeUpgradeRequiredIndicator>
				<p class="text-colorTextSecondary mb-4">
					Ask your users to verify their email address by sending them a code via email. Useful when exposing personal or sensitive data in
					a feature.
				</p>
			</div>

			<Row class="flex-justify-space-between">
				<AppSwitch class="swtch sml" v-model="localSettings.customer_auth_enabled" />
			</Row>
		</Row>
		<Row class="width-100 flex-justify-space-between" v-if="localSettings.customer_auth_enabled">
			<!--
			<AppRadioButton v-model="localSettings.customer_auth_method" :choices="authMethods">
				<template v-slot:label="{ item }">
					<div class="label">
						{{ item.title }}<span class="ml-1 sub-label">{{ item.subTitle }}</span>
					</div>
				</template>
			</AppRadioButton>
			-->
			<Col class="mb-6">
				<h3>Title</h3>
				<AppTextField v-model="localSettings.customer_auth_text" outlined class="width-100" />
				<p class="text-colorTextSecondary mb-4">
					"From" name in verification email and logo for authentication screen are set in <a @click="openSettings">workspace settings</a>.
					The fallback logo option is your workspace avatar
				</p>
				<h3>Skip authentication if the customer identity was verified</h3>
				<AppSelect
					dense
					outlined
					hide-details
					item-text="text"
					item-value="value"
					v-model="localSettings.customer_auth_duration"
					class="slct set width-100"
					:items="options"
					append-icon="fa fa-chevron-down"
				/>
			</Col>
		</Row>
	</div>
</template>

<script>
import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
import { FeatureTypes } from '@/components/Billing/billing-types';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { usePortalAuthEnabled } from '@/store/modules/featureFlags/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'PortalAuthSettingsContent',
	components: { MaybeUpgradeRequiredIndicator },
	props: {
		settings: { type: Object, required: true },
	},
	computed: {
		...mapGettersShorthand({ usePortalAuthEnabled }),
		billingFeatureId() {
			return FeatureTypes.CustomerAuthEmailSignIn;
		},
		options() {
			return [
				{ text: 'In the last 30 days', value: 2592000 },
				{ text: 'In the last 7 days', value: 604800 },
				{ text: 'In the last day', value: 86400 },
				{ text: 'In the last hour', value: 3600 },
				{ text: 'Authenticate every time', value: 0 },
			];
		},

		/*
		authMethods() {
			return [
				/*
				{
					title: `SMS verification:`,
					subTitle: `A code will be sent to the customers number.`,
					value: 'sms',
				},
				{
					title: `Email verification:`,
					subTitle: 'A code will be sent to customer address.',
					value: 'email',
					selected: true,
				},
			];
		},
		*/
	},
	methods: {
		openSettings() {
			AppDialogManagerService.openSettingsDialog({ routeName: 'SettingsOrganization' });
		},
	},
	created() {
		this.localSettings = JSON.parse(JSON.stringify(this.settings));
	},
	data() {
		return {
			localSettings: null,
		};
	},
	watch: {
		localSettings: {
			handler(newValue, oldValue) {
				if (oldValue) {
					this.$emit('update:settings', newValue);
				}
			},
			deep: true,
			immediate: false,
		},
	},
};
</script>

<style scoped lang="scss">
.title-text {
	font-size: 18px;
	font-weight: 600;
	text-align: left;
	color: var(--primary-font-color);
}
.dialog-content {
	width: 620px;
	height: 655px;
	border-radius: 10px;
	background: #ffffff;
}
.save-button {
	width: 140px !important;
	height: 45px !important;
	font-size: 14px !important;
	color: #ffffff !important;
	font-weight: 400 !important;
	letter-spacing: 0px !important;
	border-radius: 10px !important;
	text-transform: none !important;
	background: #5858ec !important;
	border: 1px solid #5858ec !important;
	&:disabled {
		border: unset !important;
	}
}
</style>
